import React, { Component } from 'react';
import { Card } from 'antd';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import { getIncuBaseList } from '@store/modules/incubator/incubator_list';

import { queryIncuSettledEorkflow } from '@api/incubator/settled';

import FormBase from '../contract/station/PageStation';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    const { incubatorList } = this.props;
    this.setState({ dataInfo });
    this.getIncuSettledEorkflow();
    if (incubatorList.length <= 0) {
      this.props.dispatch(getIncuBaseList());
    }
  }

  /**
   * 提交报销
   */
  handSubmit = item => {
    this.saveRecoup(item);
  };

  getIncuSettledEorkflow = params => {
    const { instance } = this.state;
    queryIncuSettledEorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  handleCompayChange = uuid => {
    this.getIncuSettledEorkflow({
      company: uuid,
    });
  };

  render() {
    const { isSubmitting, instance } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <FormBase
          data={this.props.data}
          isSubmitting={isSubmitting}
          onCompanyChange={this.handleCompayChange}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/incubator/settled/PageEdit.js